import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

// Fetch the complete AI trace from a landlord-research run. Returns null when no
// trace is available (a missing run, or a trace not copied into a non-prod env).
// `runId` is required and read off the persisted row (`agenticData.traceRunId` for a
// lead, `agenticTraceRunId` for a VOA row) - there is no "latest for this subject"
// fallback, so the caller only invokes this once a run_id exists.
const getLandlordResearchTrace = async (
  authToken: string,
  subjectRef: string,
  runId: string
): Promise<AITrace | null> => {
  const { data } = await axiosConfig.get(`/leads/landlord-research-trace`, {
    params: { subjectRef, runId },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data?.trace ?? null;
};

export default getLandlordResearchTrace;
